import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { MatPageable, PageableResponse } from '@core/table/mat-table';
import { PessoaCadastro } from '@core/models/pessoa';
import { HttpHeaders } from '@angular/common/http';
import { buildQueryString } from '@shared/util/util';
import { Observable, EMPTY } from 'rxjs';


const baseRef = 'pessoa';
const route = {
  consultar: `${baseRef}/consultar`,
  consultarCombo: `${baseRef}/consultar-combo`,
  salvar: `${baseRef}`,
  editar: `${baseRef}`,
  buscarPorid: (id: number) => `${baseRef}/${id}`,
  buscarPorIdBasico: (id: number) => `${baseRef}/${id}/basico`,
  possuiVinculoPrincipal: (id: number) => `${baseRef}/existe-vinculo-principal/${id}`,
  alterarstatus: (id: number, acao: string) => `${baseRef}/alterar-status/${id}/${acao}`,
  listarPorEntidadeId: (entidadeAdministradoraId: number) => `${baseRef}/entidade/${entidadeAdministradoraId}`,
  pessoaComboPaginado: `${baseRef}/consultar-combo-paginado`,
  pessoaCombo: `${baseRef}/consultar-combo`,
  pessoaVinculoComboPaginado: `${baseRef}/consultar-combo-paginado-vinculo`,
}

@Injectable({
  providedIn: 'root'
})
export class PessoaService {
  [x: string]: any;

  constructor(
    private apiService: ApiService
  ) { }

  consultar(filtro: any, page: MatPageable, ignoreLoading = false) {
    return this.apiService.post<PageableResponse<any>>(
      `${route.consultar}${page.query}`,
      this.apiService.removeNullPropertys(filtro),
      undefined,
      undefined,
      ignoreLoading
    );
  }

  consultarSort(filtro: any, page: MatPageable, params: any, ignoreLoading = false) {
    const queryString = buildQueryString({ ...params });
    const fullUrl = `${route.consultar}${page.query}${queryString}`;
    return this.apiService.post<PageableResponse<any>>(
      fullUrl,
      this.apiService.removeNullPropertys(filtro),
      undefined,
      undefined,
      ignoreLoading
    );
  }


  consultarCombo() {
    return this.apiService.get<any[]>(route.consultarCombo);
  }

  pessoaComboPaginado(filtro: any) {
    return this.apiService.get<any>(`${route.pessoaComboPaginado}/${filtro}`);
  }

  pessoaVinculoComboPaginado(filtro: any) {
    return this.apiService.get<any>(`${route.pessoaVinculoComboPaginado}/${filtro}`);
  }

  pessoaCombo() {
    return this.apiService.get<any>(`${route.pessoaCombo}`);
  }

  salvar(pessoa: PessoaCadastro) {
    return this.apiService.post<any>(route.salvar, pessoa);
  }

  buscarPorIdBasico(id: number): Observable<any> {
    const numericId = Number(id);
    if (!Number.isFinite(numericId) || numericId <= 0) {
      return EMPTY;
    }
    return this.apiService.get<any>(route.buscarPorIdBasico(numericId));
  }

  buscarPorId(id: number, ignoreLoading = true): Observable<any> {
    const numericId = Number(id);
    if (!Number.isFinite(numericId) || numericId <= 0) {
      // Evita GET /pessoa/{nome} (400) quando o form ainda tem label no control
      return EMPTY;
    }
    return this.apiService.get<any>(route.buscarPorid(numericId), undefined, undefined, ignoreLoading);
  }

  editar(pessoa: PessoaCadastro) {
    return this.apiService.put<any>(route.editar, pessoa);
  }

  inativar(id: number) {
    return this.apiService.put<any>(route.alterarstatus(id, 'Inativo'));
  }

  desbloquear(id: number) {
    return this.apiService.put<any>(route.alterarstatus(id, 'Ativo'));
  }

  listarPorEntidadeId(entidadeAdministradoraId: number) {
    return this.apiService.get<any>(route.listarPorEntidadeId(entidadeAdministradoraId));
  }

  possuiVinculoPrincipal(id: number) {
    return this.apiService.get<any>(route.possuiVinculoPrincipal(id));
  }

  verificaSeCpfJaExiste(cpf: string) {
    let cpfFormatado = cpf.replace(/\D/g, '');
    return this.apiService.get<any>(`${baseRef}/verificar-pessoa-cadastrada/${cpfFormatado}`);
  }
}
